var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPetsAndAnimals = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Dog-Head--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dog Head Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.58a4.47 4.47 0 0 1 -4.24 1.61 6.53 6.53 0 0 0 8.47 0A4.44 4.44 0 0 1 12 19.58Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.63 1.88a9 9 0 0 0 -6.08 -0.07A9.87 9.87 0 0 0 12 1.25a9.91 9.91 0 0 0 -3.56 0.56 8.94 8.94 0 0 0 -6.07 0.07C0.74 2.42 -0.14 4.34 0 7s1.33 5.54 3 5.88a2.27 2.27 0 0 0 1.16 -0.07 16.36 16.36 0 0 0 1.63 5.89c0.23 0.09 2.05 1.71 4 0.71a2.4 2.4 0 0 0 1.37 -1.8A1.56 1.56 0 0 1 10 16.25c0 -0.83 0.89 -1.5 2 -1.5s2 0.67 2 1.5a1.59 1.59 0 0 1 -1.25 1.39 2.42 2.42 0 0 0 1.34 1.77c2 1 3.72 -0.54 4 -0.62a16.19 16.19 0 0 0 1.68 -6 2.27 2.27 0 0 0 1.23 0.11c1.68 -0.34 2.85 -3.26 3 -5.88s-0.74 -4.6 -2.37 -5.14ZM9.5 12.24A1.25 1.25 0 1 1 10.75 11a1.25 1.25 0 0 1 -1.25 1.24Zm5 0A1.25 1.25 0 1 1 15.75 11a1.25 1.25 0 0 1 -1.25 1.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPetsAndAnimals);
export default ForwardRef;